import { Injectable, Injector } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId: any;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .authOnce$()
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        investmentDuration: [
          parameters?.investmentDuration || null,
          Validators.required,
        ],
      },
      options,
    );
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value;
  }
}
